export const EPR_SERVICE = "/epr-sb/v0";
export const EPR_ARCHIVE_GRADING_PROFILES = `${EPR_SERVICE}/grading_profile/historical`; // /{studentNumber}/{schoolyearkey}/index.json
export const EPR_DOWNLOAD = `${EPR_SERVICE}/grading_profile/epr/download`; // /{studentNumber}/{gradingProfileId}/detail.json
export const EPR_TIMEPERIODS_BY_SCHOOL_YEAR = `${EPR_SERVICE}/time_period/by_school_year`; // /{schoolYearKey}/index.json
